export default {
    data() {
        return {
            snapFlag: true
        };
    }
    // create() {
    // },
    // methods: {
    // }
};
